import React from "react";
import { useTranslation } from "react-i18next";
import { Col, Row, Tag } from "antd";

import AppButton from "../../../components/button";
import { INVOICE_STATUS, USER_TYPE } from "../../../constants/appConstant";

const InvoiceForm = props => {
  const { onCancel, invoiceSelected, userType, handleFormatDateLocale } = props;

  const { t } = useTranslation();

  return (
    <>
      {userType === USER_TYPE.SUPER_ADMIN && (
        <Row>
          <Col span={8}>
            <p>{t("invoices.workspace")}</p>
          </Col>
          <Col span={16}>
            <p style={invoiceFormStyle.fontWeightBold}>
              {invoiceSelected?.workspace?.name}
            </p>
          </Col>
        </Row>
      )}
      <Row>
        <Col span={8}>
          <p>{t("invoices.invoiceNumber")}</p>
        </Col>
        <Col span={16}>
          <p style={invoiceFormStyle.fontWeightBold}>
            {invoiceSelected?.invoiceNumber}
          </p>
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <p>{t("invoices.amount")}</p>
        </Col>
        <Col span={16}>
          <p style={invoiceFormStyle.fontWeightBold}>
            {invoiceSelected?.amount !== 0
              ? "AUD" +
                invoiceSelected?.amount.toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                })
              : "AUD$0"}
          </p>
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <p>{t("invoices.issueDate")}</p>
        </Col>
        <Col span={16}>
          <p style={invoiceFormStyle.fontWeightBold}>
            {/* {moment(invoiceSelected?.issueTime)
              .tz(userDetail.customer?.timeZone || moment.tz.guess())
              .format("MM/DD/YYYY HH:mm")} */}
            {handleFormatDateLocale(invoiceSelected?.issueTime)}
          </p>
        </Col>
      </Row>
      {/* <Row>
        <Col span={8}>
          <p>{t("invoices.transaction")}</p>
        </Col>
        <Col span={16}>
          <p style={invoiceFormStyle.fontWeightBold}>
            {invoiceSelected?.transaction}
          </p>
        </Col>
      </Row> */}
      <Row>
        <Col span={8}>
          <p>{t("invoices.status")}</p>
        </Col>
        <Col span={16}>
          <Tag
            bordered={false}
            style={{ borderRadius: "16px" }}
            color={
              invoiceSelected?.invoiceStatus === INVOICE_STATUS.PAID
                ? "#0E9154"
                : invoiceSelected?.invoiceStatus === INVOICE_STATUS.OVERDUE
                ? "#A9122B"
                : "#ffab00"
            }
          >
            {invoiceSelected?.invoiceStatus.toUpperCase()}
          </Tag>
        </Col>
      </Row>

      <div
        style={{
          marginTop: "16px",
          display: "flex",
          justifyContent: "end",
          gap: "16px",
        }}
      >
        <AppButton
          label={t("button.cancel")}
          color={"grey"}
          htmlType="button"
          onClick={() => {
            onCancel();
          }}
        />
      </div>
    </>
  );
};

const invoiceFormStyle = {
  fontWeightBold: {
    fontWeight: "bold",
  },
};

export default InvoiceForm;
